<template>
	<section>
		<compWrapper title="基本信息" theme="primary">
			<compFormEdit
				v-if="isEdit&&isDraft"
				class="margin-layout"
				:formdata="getBase"
				v-model="formData"
                placeholder="--"
			></compFormEdit>
			<compFormQuery v-else class="margin-layout" :formdata="getBase" :value="formData" placeholder="--"></compFormQuery>
		</compWrapper>
		<compWrapper title="产品信息" theme="primary">
			<compProduct :isEdit="isEdit&&isDraft" :data="productList" :activeType="type" ref="product"></compProduct>
			<vButtonGroup v-if="!this.isActive" slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
        <!-- <compPhotoLog v-if="!isEdit" v-bind="photoData"></compPhotoLog> -->
		<compLog v-if="!isEdit" wrapper :opActionMap="getLogActions" :data="logList"></compLog>
        <vButtonGroup v-if="this.isActive" class="text-right">
			<vButton
				v-for="item in getStatusBtns"
				:key="item.name"
				@click="item.run"
				:theme="item.theme"
			>{{item.name}}</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="getDetail"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				v-on="modalProps.on"
			/>
		</compModal>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpBillDetail, HttpSaveBill, HttpChangeBillStatus } from '@/service/salesreturns';
import compProduct from './product'
import mixin from "../mixin";
export default {
	mixins: [mixin],
    props: ['activeids', 'activeType'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
		compProduct,
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type || this.activeType,
			id: this.$route.query.id || this.activeids,
            isActive: this.activeids ? true : false,
			formData: {
				saleReturnOrderStatus: 0
			},
			productList: [],
			logList: [],//log,
			modalProps: {
				show: false,
				// title: '导入数据',
				// component: "",
				// props: {},
				// on: {},
			},
            // photoData: {}

		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('common', ['getLogActions']),
		isEdit() {
			return this.type === 'edit'
		},
		isDraft() {
			return this.formData.saleReturnOrderStatus == 0
		},
		/**
		 * 根据状态显示不同按钮
		 */
		getStatusBtns() {
			const status = this.formData.saleReturnOrderStatus;
			const btn = [{
				name: '保存',
				theme: 'primary',
				show: this.isEdit && this.isDraft && this.handleAuth('fbb.returninbound.edit'),
				run: this.save
			}, {
				name: '确认',
				theme: 'success',
				show: this.isDraft && this.handleAuth('fbb.returninbound.edit'),
				run: this.confirm
			}, {
				name: '取消',
				theme: 'error',
				show: !this.isEdit && this.isDraft && this.handleAuth('fbb.returninbound.edit'),
				run: this.cancelBill
			}, {
				name: '返回',
				theme: 'default',
				show: !this.isActive,
				run: this.cancel
			}]

			return btn.filter(item => item.show);
		},

		getBase() {
			return [{
				label: "退货入库单号",
				key: "saleReturnOrderNo",
				query: true,
			}, {
				label: "状态",
				key: "saleReturnOrderStatus",
				options: this.getBillStatus,
                render: (h) => {
                    const status = this.formData.saleReturnOrderStatus;
                    const { label = '', theme = '' } = this.getBillStatus.find(function (item) {
                        return item.value == status
                    }) || {};
                    return <vTag color={theme} type="border">{label}</vTag>
                },
				query: true,
			},
			{
				label: "退货计划单号",
				key: "saleReturnOrderPlanNo",
				query: true,
			},
			{
				label: "来源单号",
				key: "sourceNo",
				required: false,
			},
			{
				label: "仓库",
				key: "warehosueName",
				query: true,
			},
			{
				label: "项目",
				key: "lineName",
				query: true,
			},
			{
				label: "备注",
				key: "remark",
				tag: 'vTextarea',
				required: false,
			},
			];
		},
	},
	methods: {
		//获取计划单详情
		getDetail() {
			this.loading = true;
			HttpBillDetail({ id: this.id }).then(res => {
				const data = res.data || {};
				this.formData = data.saleReturnOrderBaseInfo;
                // this.photoData.orderData = this.formData;
                // this.photoData.orderType = 10;
				this.productList = (data.saleReturnOrderItems || []).map(item => {
					return {
						id: item.id, productId: item.productId, sku: item.sku, qty: item.qty, inventoryType: item.inventoryType, goodsReturnType: item.goodsReturnType, picturesUrl: item.picturesUrl, processRemark: item.processRemark, updatedAt: item.updatedAt
					}
				});
				this.logList = data.opLogEntityList;
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},

		//更新单据数据
		save() {
			this.loading = true;
			HttpSaveBill({
				id: this.id,
				saleReturnOrderBaseInfo: this.formData,
				saleReturnOrderItems: this.$refs.product.dataList
			}).then(res => {
				this.cancel();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		//确认
		async confirm() {
			this.modalProps = {
				show: true,
				title: "确认",
				alert: "success",
				showDesc: false,
				width: "middle",
				params: { id: this.id, status: 70, },
				ajaxRequest: async (params) => {
					await HttpSaveBill({
						id: this.id,
						saleReturnOrderBaseInfo: this.formData,
						saleReturnOrderItems: this.$refs.product.dataList
					});
					return await HttpChangeBillStatus(params);
				},
				formdata: [
					{
						tag: "vTextarea",
						key: "message",
						labelWidth: 'auto',
						span: 24,
						label: "备注",
					}
				],
				on: {
					'on-confirm': this.cancel
				}
			}
		},
		//确认
		async cancelBill() {
			this.modalProps = {
				show: true,
				title: "取消",
				alert: "error",
				width: "middle",
				showDesc: false,
				params: { id: this.id, status: 90, },
				ajaxRequest: HttpChangeBillStatus,
				formdata: [
					{
						tag: "vTextarea",
						key: "message",
						labelWidth: 'auto',
						span: 24,
						label: "取消原因",
						// required: false
					}
				],
				on: {
					'on-confirm': this.cancel
				}
			}
		},
		cancel() {
			this.$router.push({
				name: 'salesreturnsBill'
			})
		}
	}
};
</script>
